"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactDropzone = require("react-dropzone");
var _File = require("../File");
var _excluded = ["acceptedFileTypes", "isDisabled", "isMultipleAllowed", "maxSizeMB", "maxFilesAmount", "minSizeMB", "onFail", "onSuccess", "isFileNameDisplayed"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var WithContainer = function WithContainer(props) {
  var acceptedFileTypes = props.acceptedFileTypes,
    isDisabled = props.isDisabled,
    isMultipleAllowed = props.isMultipleAllowed,
    maxSizeMB = props.maxSizeMB,
    maxFilesAmount = props.maxFilesAmount,
    minSizeMB = props.minSizeMB,
    onFail = props.onFail,
    onSuccess = props.onSuccess,
    _props$isFileNameDisp = props.isFileNameDisplayed,
    isFileNameDisplayed = _props$isFileNameDisp === void 0 ? true : _props$isFileNameDisp,
    originalProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    addedFiles = _useState2[0],
    setAddedFiles = _useState2[1];
  var handleFail = (0, _react.useCallback)(function (failedFiles) {
    onFail === null || onFail === void 0 ? void 0 : onFail(failedFiles);
  }, [onFail]);
  var handleSuccess = (0, _react.useCallback)(function (succeedFiles) {
    var newFiles = maxFilesAmount ? [].concat((0, _toConsumableArray2["default"])(addedFiles), (0, _toConsumableArray2["default"])(succeedFiles)).filter(function (el, index) {
      return index < maxFilesAmount;
    }) : [].concat((0, _toConsumableArray2["default"])(addedFiles), (0, _toConsumableArray2["default"])(succeedFiles));
    setAddedFiles(newFiles);
    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(newFiles);
  }, [addedFiles, maxFilesAmount, onSuccess]);
  var handleRemoveClick = (0, _react.useCallback)(function (fileIndex) {
    return function () {
      var trimmedFiles = (0, _toConsumableArray2["default"])(addedFiles.filter(function (el, index) {
        return index !== fileIndex;
      }));
      setAddedFiles(trimmedFiles);
      onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(trimmedFiles);
    };
  }, [addedFiles, onSuccess]);
  var _useDropzone = (0, _reactDropzone.useDropzone)(_objectSpread(_objectSpread({}, !Array.isArray(acceptedFileTypes) ? {} : {
      accept: acceptedFileTypes
    }), {}, {
      maxFiles: maxFilesAmount || 0,
      disabled: isDisabled,
      maxSize: maxSizeMB && maxSizeMB * 1000000,
      minSize: minSizeMB && minSizeMB * 1000000,
      // react-dropzone uses bytes
      multiple: isMultipleAllowed,
      noClick: true,
      noKeyboard: true,
      onDropAccepted: handleSuccess,
      onDropRejected: handleFail
    })),
    getInputProps = _useDropzone.getInputProps,
    getRootProps = _useDropzone.getRootProps,
    isDragActive = _useDropzone.isDragActive,
    open = _useDropzone.open;
  var fileInputProps = getInputProps();
  var fileRootProps = getRootProps();
  (0, _react.useEffect)(function () {
    isFileNameDisplayed && setAddedFiles([]);
  }, [isFileNameDisplayed]);
  var injectedProps = {
    addedFiles: addedFiles,
    fileInputProps: fileInputProps,
    fileRootProps: fileRootProps,
    isDisabled: isDisabled,
    isDragActive: isDragActive,
    isMultipleAllowed: isMultipleAllowed,
    onOpenClick: open,
    onRemoveClick: handleRemoveClick
  };
  return /*#__PURE__*/_react["default"].createElement(_File.File, (0, _extends2["default"])({}, originalProps, injectedProps));
};
exports.WithContainer = WithContainer;